export const TroubleshootingWizardProcess = {
  // Abroad processes
  AbroadData: 'AbroadData',
  AbroadCellular: 'AbroadCellular',

  // Local processes
  LocalData: 'LocalData',
  LocalCellular: 'LocalCellular',
  LocalMabal: 'LocalMabal',
};
